import { AnyAction, Reducer } from 'redux';

export const STORE_SEARCHNAME = 'search/user-orders';
export const STORE_SEARCHVALUE = 'search/search-value';
export const STORE_SEARCHLOADING = 'search/search-loading';
export const STORE_SEARCHTRUE = 'search/search-true';
export const STORE_SEARCHTYPE = 'search/search-type';
export const STORE_NOTIFICATIONS = 'notifications/notifications-icon';
export const STORE_NOTIFICATIONS_COUNT = 'notifications/notifications-count';

export const STORE_OPEN_VIDEO_PLAYER = 'video-player/open-dialog';
export const STORE_VIDEO_SIGNED_URL = 'video-player/signed-url';
export const STORE_LOADER = 'full-screen-loader';
export const STORE_VERTICAL_VIEW_SCREEN = 'vertical-view-screen';

export interface SearchValue {
    rowno: string;
    sresult: string;
    dsordersid: string;
    orderno: string;
}

export interface NotificationsType {
    rowno: string;
    id: string;
    message: string;
    createdon: string;
    status: string;
    updatedon: string;
    orderno: string;
    dsordersid: string;
    feedback: string;
}

export interface LandingPageState {
    searchName?: string;
    searchValue?: SearchValue[];
    searchLoading?: Boolean;
    searchTrue?: boolean;
    searchType?: string;
    notifications: NotificationsType[];
    notificationCount: Number;
    openVideoPlayer: boolean;
    videoSignedUrl: string[];
    loader: boolean;
    verticalViewScreen: boolean;
}

const initialState: LandingPageState = {
    searchName: '',
    searchValue: [],
    searchLoading: false,
    searchTrue: false,
    searchType: '',
    notifications: [],
    notificationCount: 0,
    openVideoPlayer: false,
    videoSignedUrl: [],
    loader: false,
    verticalViewScreen: false
};

const reducer: Reducer<LandingPageState> = (state: LandingPageState = initialState, action: AnyAction): LandingPageState => {
    switch (action.type) {
        case STORE_SEARCHNAME:
            return {
                ...state,
                searchName: action.searchName
            };
        case STORE_SEARCHVALUE:
            return {
                ...state,
                searchValue: action.searchValue
            };
        case STORE_SEARCHLOADING:
            return {
                ...state,
                searchLoading: action.searchLoading
            };
        case STORE_SEARCHTRUE:
            return {
                ...state,
                searchTrue: action.searchTrue
            };
        case STORE_SEARCHTYPE:
            return {
                ...state,
                searchType: action.searchType
            };
        case STORE_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.notifications
            };
        case STORE_NOTIFICATIONS_COUNT:
            return {
                ...state,
                notificationCount: action.notificationCount
            };
        case STORE_OPEN_VIDEO_PLAYER:
            return {
                ...state,
                openVideoPlayer: action.openVideoPlayer
            };
        case STORE_VIDEO_SIGNED_URL:
            return {
                ...state,
                videoSignedUrl: action.videoSignedUrl
            };
        case STORE_LOADER:
            return {
                ...state,
                loader: action.loader
            };
        case STORE_VERTICAL_VIEW_SCREEN:
            return {
                ...state,
                verticalViewScreen: action.verticalViewScreen
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/landingPage.tsx